/**
 * INBAR+co — Journal Post Scripts
 * File: assets/inbar-journal-post.js
 *
 * Handles:
 * - Reading progress indicator
 * - Smooth scroll-entrance for content sections
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var ic = document.querySelector('.ic');
    if (!ic) return;

    /* ─────────────────────────────────────────────
       READING PROGRESS BAR
    ───────────────────────────────────────────── */
    var progressBar = document.createElement('div');
    progressBar.style.cssText = [
      'position:fixed',
      'top:0',
      'left:0',
      'height:2px',
      'width:0%',
      'background:var(--inbar-black)',
      'z-index:9999',
      'transition:width 0.1s linear',
      'pointer-events:none'
    ].join(';');
    document.body.appendChild(progressBar);

    function updateProgress() {
      var body = document.body;
      var docEl = document.documentElement;
      var scrollTop = window.scrollY || docEl.scrollTop;
      var scrollHeight = Math.max(
        body.scrollHeight, docEl.scrollHeight,
        body.offsetHeight, docEl.offsetHeight
      ) - window.innerHeight;
      var pct = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
      progressBar.style.width = Math.min(pct, 100) + '%';
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();

    /* ─────────────────────────────────────────────
       CONTENT ENTRANCE
    ───────────────────────────────────────────── */
    var fadeEls = document.querySelectorAll(
      '.ic-post-quote, .ic-post-table-wrap, .ic-post-ledger, .ic-post-figure'
    );
    if (!fadeEls.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ic-post--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeEls.forEach(function (el) {
      el.classList.add('ic-post--hidden');
      observer.observe(el);
    });
  });

})();
